import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { OtherProfessionalPositionApiRepository } from '../repositories/other-professional-position-api.repository';
import { OtherProfessionalPositionCacheRepository } from '../repositories/other-professional-position-cache.repository';
import { OtherProfessionalPositionInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class OtherProfessionalPositionProvider {
    constructor(
        private otherProfessionalPositionApiRepository: OtherProfessionalPositionApiRepository,
        private otherProfessionalPositionCacheRepository: OtherProfessionalPositionCacheRepository
    ) {}

    find(): Observable<Transaction<OtherProfessionalPositionInterface[]>> {
        return concat(
            this.otherProfessionalPositionCacheRepository.load(),
            this.otherProfessionalPositionApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.otherProfessionalPositionCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
